<template>
  <nav>
    <b-container>
      <b-row>
        <b-col
          v-for="(nav, i) in navAwards"
          :key="i"
          @click.prevent="clickNav(nav.title)"
          cols="12"
          md="4"
          class="col"
        >
          <div
            class="box-nav"
            :class="[ nav.active ? 'active' : '' ]"
          >
            <div class="box-img">
              <img src="">
            </div>
            <div class="box-text">
              <p>{{ nav.title }}<span>{{ nav.dec }}</span></p>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </nav>
</template>

<script>
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState({
      navAwards: state => state.nav.navAwards
    })
  },

  methods: {
    clickNav (title) {
      this.$store.dispatch('nav/awards', title)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/variables.scss';

nav{
  background-color: $light;

  .container {
    .row {
      .col {
        cursor: pointer;

        @media only screen and (min-width: $break-m) {
          padding: 0;
        }

        .box-nav {
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 12px;
          border-bottom: 1px solid #CCC;

          @media only screen and (min-width: $break-m) {
            padding: 18px;
            border: none;
            border-style: solid;
            border-width: 0 1px 0 1px;
            border-color: #CCC;
          }

          .box-img {
            img {
              width: 52px;
              height: 52px;
              background: red;
            }

            @media only screen and (min-width: $break-m) {
              display: none;
            }
          }

          .box-text {
            margin-left: 12px;
            font-size: 1.25rem;
            color: #636363;

            @media only screen and (min-width: $break-m) {
              font-size: 1.5rem;
            }

            p {
              span {
                margin-top: -12px;
                display: block;
                opacity: 0.5;

                @media only screen and (min-width: $break-m) {
                  margin-left: 12px;
                  display: inline-block;
                }
              }
            }
          }
        }

        .active {
          border-bottom: 3px solid $active;
        }
      }
    }
  }
}
</style>
